import { Tag } from "antd";
import { t } from "i18next";
import * as React from "react";

import * as styles from "./ClosableTag.module.less";

type PropsClosableTag = {
  filterLabel?: React.ReactNode;
  label?: React.ReactNode;
  onClose?: () => void;
};

/**
 * Тег, используемый для индикации и сброса фильтра, выбранного в дереве классов
 */
export const ClosableTag: React.FC<PropsClosableTag> = ({
  filterLabel = `${t("Filter")}:`,
  label,
  onClose,
}) => (
  <span className={styles.filtersBox}>
    <span className={styles.filtersLabel}>{filterLabel}</span>
    {label && (
      <Tag closable color="volcano" onClose={onClose}>
        {label}
      </Tag>
    )}
  </span>
);
